import * as tslib_1 from "tslib";
import mailStore from 'owa-mail-store/lib/store/Store';
export default function getConversationNodeId(conversationId, itemId) {
    var e_1, _a, e_2, _b;
    if (mailStore.conversations.has(conversationId)) {
        var conversationItemParts = mailStore.conversations.get(conversationId);
        try {
            for (var _c = tslib_1.__values(conversationItemParts.conversationNodeIds), _d = _c.next(); !_d.done; _d = _c.next()) {
                var conversationNodeId = _d.value;
                var conversationNode = mailStore.conversationNodes.get(conversationNodeId);
                try {
                    for (var _e = tslib_1.__values(conversationNode.itemIds), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var id = _f.value;
                        if (id == itemId) {
                            return conversationNodeId;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return null;
}
//# sourceMappingURL=getConversationNodeId.js.map